import { queryOptions } from "@tanstack/react-query";
import { Paginated, Avatar } from "@vixi/types";
import { api, endpoints } from "@vixi/api";
import { CHARACTER_TYPE } from "@vixi/types";

/**
 * Query options to get the count of ALL avatars.
 * Uses the getAvatars endpoint.
 *
 * @returns Query options that return the total count of all avatars
 */
export const allAvatarsCountQueryOptions = () =>
  queryOptions({
    queryKey: ["allAvatarsCount"],
    queryFn: async () => {
      const response = await api.get<Paginated<Avatar>>(endpoints.getAvatars, {
        params: {
          pageNumber: 1,
          pageSize: 1,
          characterType: CHARACTER_TYPE.COURSE_CHARACTER,
        },
      });

      return response.data.totalCount ?? 0;
    },
  });
